var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtmIcnArrowWhiteLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 10,
    viewBox: "0 0 29 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "eqfeo0a1ka"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#eqfeo0a1ka)",
    transform: "translate(-843 -573) translate(136 564) translate(357)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.013 2.013L27.002 1.987 26.977 7.977z",
    transform: "translate(350 9) rotate(45 24.008 4.982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.986H24V5.979H0z",
    transform: "translate(350 9)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmIcnArrowWhiteLarge);
export default __webpack_public_path__ + "static/media/atm-icn-arrow-white-large.08f3327bba9112096475c0f38025a50f.svg";
export { ForwardRef as ReactComponent };